import React, { useState } from "react";
import Logo from "../../assets/images/logo.png";
import { ReduceBurdenIcon, IncreaseRevenueIcon, KeepSecureIcon, PlayIcon } from "../../assets/icons/onboarding";
import ReactPlayer from "react-player";
import VideoPoster from "../../assets/images/leftpanel-video-poster.png";

interface LeftPanelProps {
  title?: string;
  description?: string;
  helpLinkText?: string;
  helpLinkUrl?: string;
  videoSrc?: string;
  videoThumbnail?: string;
  onVideoPlay?: () => void;
}

const LeftPanel: React.FC<LeftPanelProps> = ({
  title = "Docnote Office Setup",
  description = "This guided setup will show you how to complete your office setup step-by-step so you can get started quickly. You can always edit or update this information later on.",
  helpLinkText = "Learn more in the Help Center →",
  helpLinkUrl = "https://help.docnote.com/en",
  videoSrc = "https://www.youtube.com/watch?v=TLeoEC8otPo&t=1s",
  videoThumbnail,
  onVideoPlay,
}) => {
  const [showVideo, setShowVideo] = useState(false);

  const handleVideoClick = () => {
    setShowVideo(true);
    if (onVideoPlay) {
      onVideoPlay();
    }
  };

  // Static features that appear on all steps
  const features = [
    {
      icon: <ReduceBurdenIcon />,
      text: "Reduce Administrative Burden",
    },
    {
      icon: <IncreaseRevenueIcon />,
      text: "Increase Revenue",
    },
    {
      icon: <KeepSecureIcon />,
      text: "Keep Data Secure",
    },
  ];
  return (
    <div className="w-1/3 max-w-[448px] bg-docsigna-purple hidden md:flex flex-col justify-between p-8">
      <div className="">
        {/* <div className="relative">
          <div className="relative w-full h-48 rounded-lg overflow-hidden cursor-pointer" onClick={handleVideoClick}>
            <img
              src={videoThumbnail || VideoPoster}
              alt="Video thumbnail"
              className={`w-full h-full object-cover relative z-1 ${!showVideo ? "block" : "invisible opacity-0"}`}
            />

            {!showVideo && (
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-0 hover:bg-opacity-20 transition-all z-10 opacity-0">
                <PlayIcon width={48} height={48} />
              </div>
            )}

            <div className="absolute left-0 top-0 w-full h-full z-0">
              <div className={`w-full h-full ${showVideo ? "block" : "invisible opacity-0"}`}>
                <ReactPlayer url={videoSrc} playing={showVideo} controls width="100%" height="100%" />
              </div>
            </div>
          </div>
        </div> */}

        <h2 className="text-white mt-6 leading-6 tracking-[-0.3px]">{title}</h2>

        <p className="text-[#D1D5DC] leading-relaxed mt-3 text-sm leading-[20px] tracking-[-0.15px]">{description}</p>

        {/* <a
          href={helpLinkUrl}
          target="_blank"
          className="text-[#D4F14E] mt-6 text-sm leading-[20px] hover:underline inline-flex items-center"
          rel="noreferrer">
          {helpLinkText}
        </a> */}
      </div>

      {/* Features Section */}
      <div className="mt-10 space-y-4 pt-8 border-t border-white/10">
        {features.map((feature, index) => (
          <div key={index} className="flex items-center space-x-3">
            <div className="flex-shrink-0 text-[#D4F14E]">{feature.icon}</div>
            <span className="text-white text-sm leading-[20px] tracking-[-0.15px]">{feature.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeftPanel;
